import BeautyInsiderAllRewards from './BeautyInsiderAllRewards.f';
import { withBeautyInsiderAllRewardsProps } from 'viewModel/content/BeautyInsider/withBeautyInsiderAllRewardsProps';

export default withBeautyInsiderAllRewardsProps(BeautyInsiderAllRewards);
